var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 15987",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 202",
    d: "M0 0h48v48H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34a1 1 0 002 0 8.934 8.934 0 015.2-8.13 6.958 6.958 0 007.615-.008 9.125 9.125 0 012.55 1.775A8.942 8.942 0 0133 34a1 1 0 002 0 10.928 10.928 0 00-3.223-7.777 11.074 11.074 0 00-2.371-1.784 7 7 0 10-10.822-.009A10.934 10.934 0 0013 34zm11-19a5 5 0 11-5 5 5.006 5.006 0 014.999-5z",
    fill: "#fff"
  })));
}

export default SvgContactsIcon;